const KEY = "c2g_promo";

export const getPromo = () => localStorage.getItem(KEY) || "";
export const clearPromo = () => localStorage.removeItem(KEY);

const fromUrl = new URLSearchParams(window.location.search).get("codice") || new URLSearchParams(window.location.search).get("code");
if (fromUrl && /^[A-Za-z0-9_-]{2,40}$/.test(fromUrl)) localStorage.setItem(KEY, fromUrl.toUpperCase());
